module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.a3e0b5f4.ttf";